import { Component, OnInit } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { MainService } from 'src/app/services/main.service';
import { PrintService } from 'src/app/lazy/private/services/print.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
}

@Component({
  selector: 'app-billreport',
  templateUrl: './billreport.component.html',
  styleUrls: ['./billreport.component.css']
})
export class BillreportComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit{

  constructor(public dialogService: DialogService, private pos: PosService,private ms: MainService, private prs: PrintService) { 
    super(dialogService);
  }
  
  title: string;
  InvNoList: any;
  selectedIx = 0;
  selectedInvNo: any;
  loading_InvNo = false;
  loading_Sales = false;
  salesModel: any;

  ngOnInit() {
    this.loadInvNoList();
  }

  loadInvNoList() {
    this.loading_InvNo = true;
    const s = this.ms.getSettings();
    const t = {
      LocationId: s.LocId,
      Id: s.CounterOpenId,
      DayOpenId: s.DayOpenId
    };
    this.pos.GetSalesInvNoList(t).subscribe(res => {
      if (res.Success) {
        this.InvNoList = res.data;
        this.next_Click('');
      }
      this.loading_InvNo = false;
    });
  }

  next_Click(click = '>') {
    if (click === '>') {
      this.selectedIx++;
    } else if (click === '>>') {
      this.selectedIx = this.InvNoList.length - 1;
    } else if (click === '<') {
      this.selectedIx--;
    } else if (click === '<<') {
      this.selectedIx = 0;
    } else {
      this.selectedIx = 0;
    }
    if (this.InvNoList.length <= this.selectedIx || this.selectedIx < 0) {
      return;
    }
    this.selectedInvNo = this.InvNoList[this.selectedIx];
    const s = this.ms.getSettings();
    let d = {
      InvNo: this.selectedInvNo.InvNo,
      LocationId: s.LocId,
      ItemTypeId: 1,
      SellingPriceLevelId: s.SellingPriceLevelId
    };
    this.loading_Sales = click == '';
    this.pos.GetSalesByInvNo(d).subscribe(res => {
      if (res.Success) {
        this.salesModel = res.data;
      }
      this.loading_Sales = false;
    });
  }

  btnClose() {
    this.close();
  }

  print_btn() {
    this.prs.SendToPrinter(this.salesModel, 3);
  }

}
